export default {
    getApplicantInfo: state => {
        return state.applicantInfo;
    },
    getDocumentsInfo: state => {
        return state.documentsInfo;
    },
    getErrors: state => {
        return state.errors;
    }
}